import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import NotFound from "../notfound";
import NotAllowed from "../notallowed";
import Blue from "../pages/blue";
import Purple from "../pages/purple";
import Red from "../pages/red";
import Pink from "../pages/pink";
import { connect } from "react-redux";

class Routes extends Component {
  render() {
    const { xdr_edr, xdr, xdr_cm, xdr_tm, xdr_soar,compliance_gsos,compliance, xdrp, xdrp_nd, xdrp_pm, oxdr, oxdr_asm,oxdr_bas,oxdr_ro,oxdr_vm , oxdr_phish } = { ...this.props?.posts[0] };

    return (
      <BrowserRouter>
        <Switch>
          {/* homepage based on roles (blue red purple pink) */}
          {(() => {            if(this.props?.posts[0]) {
              if (xdr === true || xdr_edr === true || xdr_cm === true || xdr_tm === true || xdr_soar === true ) {
                return <Route path="/" exact component={Blue}  />;
              } else if (xdrp === true || xdrp_nd === true || xdrp_pm === true) {
                return <Route path="/" exact component={Purple} />;
              } else if (oxdr === true || oxdr_asm === true || oxdr_bas === true || oxdr_ro === true || oxdr_vm === true || oxdr_phish === true) {
                return <Route path="/" exact component={Red} />;
              } else if (compliance_gsos === true || compliance === true){
                return <Route path="/" exact component={Pink} />;
              }
            }
          })()}

          {/* || this.props.posts.map((post) => post.blue_edr)[0] === true */}

          {/* routes based on roles */}
          {(xdr === true || xdr_edr === true || xdr_cm === true || xdr_tm === true || xdr_soar === true)  && (
            <Route path="/xdr" exact component={Blue}  />
          )}
          {(xdrp === true || xdrp_nd === true || xdrp_pm === true) && (
            <Route path="/xdrp" exact component={Purple} />
          )}
          {(oxdr === true || oxdr_asm === true || oxdr_bas === true || oxdr_ro === true || oxdr_vm === true || oxdr_phish === true) && (
            <Route path="/oxdr" exact component={Red} />
          )}
          {(compliance_gsos === true || compliance === true) && (
            <Route path="/compliance" exact component={Pink} />
          )}

          {/* error routes */}
          <Route path="/404" exact component={NotFound} />
          <Route path="/403" exact component={NotAllowed} />

          {/* restricted routes for non admin */}
          <Route path="/users" exact component={NotAllowed} />
          <Route path="/add-user" exact component={NotAllowed} />
          <Route path="/settings" exact component={NotAllowed} />
          <Route path="/reports" exact component={NotAllowed} />

          {/* error for other pages */}
          <Route path="/*" exact component={NotFound} />
        </Switch>
      </BrowserRouter>
    );
  }
}
const mapStateToProps = (state) => {
  return { posts: state.posts };
};

export default connect(mapStateToProps)(Routes);
